import type { components } from '@connected/api-client/api.generated';

import type { FileRouteTypes } from '@/routeTree.gen';

type routes = FileRouteTypes['to'];

export const validationLinks: Partial<Record<
    components['schemas']['ElectricalProjectValidationResultObjectKind'],
    routes | Partial<Record<components['schemas']['ElectricalProjectDistributionBoardDeviceKind'], routes>> | Partial<Record<'DistributionBoard' | 'FinalCircuit', routes>>
>> = {
    DistributionBoard: '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/information',
    FinalCircuit: '/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId/information',
    CheckListItem: {
        DistributionBoard: '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/checklist',
        FinalCircuit: '/projects/$projectVersionId/re-inspections/final-circuits/$finalCircuitId/checklist',
    },
    DistributionBoardDevice: {
        FinalCircuitProtectiveDevice: '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/final-circuit-protective-devices',
        ResidualCurrentCircuitBreakerDevice: '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/residual-current-circuit-breakers',
        ResidualCurrentDevice: '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/board/residual-current-devices',
        IsolationResistanceMeasurement: '/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId/devices/$distributionBoardDeviceId/resistance-measurements',
    },
    BuildingFunction: '/projects/$projectVersionId/applications/objects',
    TechnicalDrawing: '/projects/$projectVersionId/applications/drawings',
    Object: '/projects/$projectVersionId/applications/objects',
    InspectionSchedule: '/projects/$projectVersionId/schedules',
};

export function LinkToValidation(itemError: components['schemas']['ElectricalProjectValidationResult']): routes {
    if (!itemError?.ObjectKind) {
        return '/projects/$projectVersionId/re-inspections/summary';
    }

    if (itemError?.ObjectKind !== 'CheckListItem' && itemError?.ObjectKind !== 'CheckListItemObservation' && itemError?.ObjectKind !== 'DistributionBoardDevice')
        return validationLinks[itemError.ObjectKind] as routes;

    if (itemError?.ObjectKind === 'CheckListItem' || itemError?.ObjectKind === 'CheckListItemObservation') {
        const checkListLinks = validationLinks?.CheckListItem;
        if (checkListLinks && typeof checkListLinks === 'object' && 'DistributionBoard' in checkListLinks) {
            if (itemError?.DistributionBoard)
                return checkListLinks.DistributionBoard as routes;
            if (itemError?.FinalCircuit)
                return checkListLinks.FinalCircuit as routes;
        }

        return '/projects/$projectVersionId/re-inspections/summary';
    }

    if (itemError?.ObjectKind === 'DistributionBoardDevice') {
        const deviceLinks = validationLinks?.DistributionBoardDevice;
        if (deviceLinks && typeof deviceLinks === 'object') {
            const deviceKind = itemError?.DistributionBoardDevice?.DeviceKind;
            if (deviceKind && deviceKind in deviceLinks && deviceLinks[deviceKind as keyof typeof deviceLinks]) {
                return deviceLinks[deviceKind as keyof typeof deviceLinks] as routes;
            }
        }
    }

    return '/projects/$projectVersionId/re-inspections/summary';
}
